import { keyJwt } from "../../utils/helpers/helpers";

class TokenService {
  getToken() {
    let c = localStorage.getItem(keyJwt); //toma el valor de Jwt que se esta en el almacenamiento local
    //si la clave JWT no existe devuelve  null
    if (c && c !== "") {
      return c.substring(1, c.length - 1);
    }
    return null;
  }
}
export default new TokenService();
